var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_details"},[_c('span',[_vm._v("查看详情")]),_c('el-image',{staticClass:"view_details_image_warp",attrs:{"src":require('@/assets/common/viewDetailsImage.png'),"fit":"scale-down","lazy":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }